import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Select, ValueButton } from "@activecollab/components";
import PropTypes from "prop-types";
import i18n from "~/i18n";

const groups = [
  {
    id: "start_date",
    name: i18n.t("By Start Date"),
  },
  {
    id: "date",
    name: i18n.t("By Due Date"),
  },
  {
    id: "project",
    name: i18n.t("By Project"),
  },
];

export const MyGroupedByPicker = ({ groupedBy, onChange }) => {
  const { t } = useTranslation();
  const labelText = useMemo(() => {
    let label = t("By Project");

    if (groupedBy === "date") {
      label = t("By Due Date");
    }

    if (groupedBy === "start_date") {
      label = t("By Start Date");
    }

    return label;
  }, [groupedBy, t]);

  const [open, setOpen] = useState(false);
  const onSelectOpen = useCallback(() => setOpen(true), []);
  const onSelectClose = useCallback(() => setOpen(false), []);

  return (
    <div className="my_tasks_group_by_wrapper tw-flex">
      <Select
        options={groups}
        target={
          <ValueButton
            active={open}
            value={labelText}
            label={t("Group")}
          />
        }
        onChange={onChange}
        selected={groupedBy}
        forceCloseMenu
        disableSearch
        keepSameOptionsOrder
        onSelectOpen={onSelectOpen}
        onSelectClose={onSelectClose}
        position="bottom-end"
        disabledInternalSort
      />
    </div>
  );
};

MyGroupedByPicker.propTypes = {
  groupedBy: PropTypes.string,
  onChange: PropTypes.func,
};

MyGroupedByPicker.defaultProps = {
  groupedBy: "project",
  onChange: () => null,
};
